import login from './login';

export default {
  language: 'sv',
  country: 'se',
  name: 'Svenska',
  embeddedLocale: login,
  flags: ['SE'],
};
